import React, { Component } from 'react';

export class ColorDisplayer extends Component {
    render() {
        const { color, cursor, onClick } = this.props;
        const isUseLineColor = "useLineColor" === color;

        const style = {
            cursor: undefined === cursor ? "default" : cursor,
            ...(isUseLineColor ? {} : { backgroundColor: color }),
        };

        return (
            <div>
                <span
                    className={isUseLineColor ? "span-use-line-color" : "span-colors"}
                    style={style}
                    onClick={onClick}
                >
                    {isUseLineColor ? 'L' : null}
                </span>
            </div>
        );
    }
}

